import { HStack, PinInput, PinInputField } from "@chakra-ui/react";
import { FC } from "react";

interface OTPInputProps {
	length?: number;
	value: string;
	onChange: (value: string) => void;
	isDisabled?: boolean;
	autoFocus?: boolean;
}

const OTPInput: FC<OTPInputProps> = ({
	length = 6,
	value,
	onChange,
	isDisabled = false,
	autoFocus = true,
}) => {
	console.log(value);
	return (
		<HStack justify="center" spacing="2" dir="ltr">
			<PinInput
				value={value}
				onChange={onChange}
				isDisabled={isDisabled}
				autoFocus={autoFocus}
				otp
				size="md"
			>
				{Array.from({ length }).map((_, index) => (
					<PinInputField key={index} w="12" h="12" fontSize="xl" />
				))}
			</PinInput>
		</HStack>
	);
};

export default OTPInput;
